{
  "features-debit-card-no-ssn": {
    "meta": {
      "title": "Visa® Debit Card without SSN - MAJORITY",
      "description": "Get a free MAJORITY Visa Debit Card whether or not you have an SSN and save with cashback, discounts, no hidden fees, and more."
    },
    "hero": {
      "title": "Visa® Debit Card without SSN",
      "body": "Get a free MAJORITY Visa Debit Card whether or not you have an SSN and save with cashback, discounts, no hidden fees, and more.",
      "cta": "Get started",
      "circle": "No SSN required"
    },
    "no_ssn_content_box": {
      "tagline": "Visa Debit Card",
      "title": "Get a free Debit Card, no SSN required",
      "body": "Regardless of immigration status, everyone deserves access to basic financial services. That’s why we’re partnering with Axiom Bank, N.A. to offer an account and free Visa® Debit Card even without an SSN. Simply verify your identity with a government-issued ID, such as a passport or matrícula consular.",
      "canvas": "No SSN, no problem",
      "cta": "Get started"
    },
    "cashback": {
      "title": "Earn cashback for supporting local",
      "body": "Swipe with pride and save when you use your MAORITY Visa Debit Card. We’ve partnered with migrant-owned businesses to bring you cashback and discounts at your favorite local grocery stores, restaurants, and more. Plus, we offer tons of cashback deals at national retailers.",
      "cta": "See discounts"
    }
      }
}